import { initialize } from './Initialize';
let pluginRegistry = undefined;
export const registerPlugin = (pluginName, pluginHandler) => {
  if (!pluginRegistry) {
    pluginRegistry = {};
  }
  pluginRegistry[pluginName] = pluginHandler;
};
export const getPlugin = pluginName => {
  if (!pluginRegistry) {
    initialize({
      registerPlugin
    });
  }
  if (pluginRegistry && pluginRegistry[pluginName]) {
    return pluginRegistry[pluginName]();
  }
  return Promise.reject(new Error(`Plugin ${pluginName} not found.`));
};
export const __TESTABLE__ = {
  reset: () => {
    pluginRegistry = undefined;
  }
};